import { Reducer } from 'redux'
import { createFilter } from 'redux-persist-transform-filter'

import { AuthState, AuthActionTypes } from './types'

export const FILTER_PERSISTOR = createFilter(
  'auth',
  null,
  ['access_token', 'refresh_token'],
  'whitelist'
)

const INITIAL_STATE: AuthState = {
  access_token: null,
  error: false,
  forgot_password: null,
  loading: false,
  refresh_token: null
}

const reducer: Reducer<AuthState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    case AuthActionTypes.AUTH_BY_USERNAME:
    case AuthActionTypes.AUTH_BY_QR_CODE:
      return { ...state, error: false, loading: true }
    case AuthActionTypes.AUTH_FAILURE:
      return { ...state, error: true, loading: false }
    case AuthActionTypes.AUTH_FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgot_password: {
          message: payload.message,
          type: 'error'
        },
        loading: false
      }
    case AuthActionTypes.AUTH_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgot_password: {
          message: payload.message,
          type: 'success'
        },
        loading: false
      }
    case AuthActionTypes.AUTH_FORGOT_PASSWORD:
      return { ...state, forgot_password: null, loading: true }
    case AuthActionTypes.AUTH_LOGOUT:
      return { ...INITIAL_STATE }
    case AuthActionTypes.AUTH_SUCCESS:
      return { ...state, ...payload.response, loading: false }
    default:
      return state
  }
}

export default reducer
